import type { UseFormReturn } from 'react-hook-form';

import { FormCheckbox, FormField, FormInput, FormNumberInput } from '@/_components';
import { FormCurrencyInput, FormInputUrl } from '@/_containers';

import type { InventoryVendorFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<InventoryVendorFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 md:col-span-4"
            label="Vendor (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="vendor_id"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 md:col-span-4"
            label="Vendor ID (required)"
            {...field}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="account_number"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 md:col-span-4"
            label="Account Number (required)"
            {...field}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="sku_label"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 md:col-span-4"
            label="SKU Label (required)"
            {...field}
            disabled={!isEditable}
          />
        )}
      />
      <FormField
        control={form.control}
        name="sku_start_number"
        render={({ field }) => (
          <FormNumberInput
            formItemClassName="col-span-12 sm:col-span-6 md:col-span-4"
            label="SKU Start Number (required)"
            {...field}
            disabled={!isEditable}
            value={field.value}
            onValueChange={(s) => {
              field.onChange(s.value);
            }}
          />
        )}
      />
      <FormField
        control={form.control}
        name="tax_id"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 md:col-span-4"
            label="Tax ID"
            {...field}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="url"
        render={({ field }) => (
          <FormInputUrl
            formItemClassName="col-span-12 sm:col-span-6 md:col-span-4"
            label="URL"
            {...field}
            disabled={!isEditable}
          />
        )}
      />

      <FormCurrencyInput
        isEditable={isEditable}
        name="credit_limit"
        label="Credit Limit"
        formItemClassName="col-span-12 sm:col-span-6 md:col-span-4"
      />

      <div className="col-span-12">
        <FormField
          control={form.control}
          name="minimum_order_required"
          render={({ field }) => (
            <FormCheckbox
              label="Minimum Order Required"
              disabled={!isEditable}
              checked={!!field.value}
              onChange={(e) => {
                field.onChange(e.target.checked);
              }}
            />
          )}
        />
      </div>
    </>
  );
}
